import { render, staticRenderFns } from "./SmallProject.vue?vue&type=template&id=a0c34dd0&scoped=true&"
import script from "./SmallProject.vue?vue&type=script&lang=js&"
export * from "./SmallProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c34dd0",
  null
  
)

export default component.exports